export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13702.18d495bb.jpg";